import styled from 'styled-components'
import CustomLink from '../../CustomLink'

export const StyledNavigationLink = styled(CustomLink) <{
  $inverted?: boolean
  $fullwidth?: boolean
  $activeClassName?: string
  $useTheme?: boolean
  $bordered?: boolean
}>`
  align-items: ${p => (p.$fullwidth ? 'left' : 'center')};
  background: transparent;
  border: 0;
  color: ${({ $inverted, theme }) => ($inverted ? theme.colors.white[1] : 'var(--c-theme-2)')};
  cursor: pointer;
  display: ${p => (p.$fullwidth ? 'flex' : 'inline-flex')};
  font-size: 0.95rem;
  gap: 0.4rem;
  justify-content: ${p => (p.$fullwidth ? 'left' : 'center')};
  line-height: 1.2;
  padding: 0.4rem 0.6rem;
  position: relative;
  text-decoration: none;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
  max-width: 100%;
  width: ${p => (p.$fullwidth ? '100%' : 'auto')};

  .label {
    align-items: center;
    display: flex;
    gap: 0.2rem;
    position: relative;
    z-index: 2;
  }

  &:before {
    background-color: ${({ $inverted }) => ($inverted ? 'var(--c-theme-2)' : 'transparent')};
    border-radius: 0.6rem;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: background-color 0.15s, left 0.2s, right 0.2s, top 0.2s, bottom 0.2s;
    z-index: 1;

    border: ${({ $bordered }) => ($bordered ? 'grey 1px solid' : '')};
  }

  &.active {
    font-weight: bold;
  }
`
export const StyledAnnouncmentLink = styled(CustomLink) <{
  $inverted?: boolean
  $fullwidth?: boolean
  $activeClassName?: string
  $useTheme?: boolean
}>`
  align-items: ${p => (p.$fullwidth ? 'left' : 'center')};
  background: transparent;
  border: 0;
  color: ${({ $inverted, theme }) => ($inverted ? theme.colors.white[1] : 'var(--c-theme-2)')};
  cursor: pointer;
  display: ${p => (p.$fullwidth ? 'flex' : 'inline-flex')};
  font-size: 0.95rem;
  gap: 0.4rem;
  justify-content: ${p => (p.$fullwidth ? 'left' : 'center')};
  line-height: 1.2;
  padding: 0.4rem 0.6rem;
  position: relative;
  text-decoration: none;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
  max-width: 100%;
  width: ${p => (p.$fullwidth ? '100%' : 'auto')};

  .label {
    align-items: center;
    display: flex;
    gap: 0.2rem;
    position: relative;
    z-index: 2;
  }

  &:before {
    border-radius: 0.6rem;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: transform 0.15s, left 0.2s, right 0.2s, top 0.2s, bottom 0.2s;
    z-index: 1;
  }

  &.active {
    font-weight: bold;
  }
`

export const LabelInner = styled.span<{ $fullwidth?: boolean }>`
  align-items: center;
  display: ${p => (p.$fullwidth ? 'flex' : 'inline-flex')};
  justify-content: ${p => (p.$fullwidth ? 'space-between' : 'space-around')};
  text-align: ${p => (p.$fullwidth ? 'left' : 'center')};
  width: ${p => (p.$fullwidth ? '100%' : 'auto')};
  max-width: 100%;
`
